/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponProductChangeDetail {
  brandName?: string;
  changed?: boolean;
  couponPriceChangeId?: number;
  couponProductChangeId?: number;
  couponProductVariantType?: number;
  couponProductVariantTypeName?: string;
  dateCreated?: Date;
  defaultImageURL?: string;
  groupVariant?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  ratingAverage?: number;
  reviewCount?: number;
  userEmail?: string;
  userId?: number;
  userName?: string;
}
